<script lang="ts" setup></script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3 2" aria-hidden="true">
    <rect width="1" height="2" x="0" y="0" fill="#009246" />
    <rect width="1" height="2" x="1" y="0" fill="#ffffff" />
    <rect width="1" height="2" x="2" y="0" fill="#ce2b37" />
  </svg>
</template>
